import React, { Component } from 'react'
import ItemAnexo from './components/ItemAnexo'


import FileUploader from "react-firebase-file-uploader";
import {   Typography} from '@material-ui/core';
import View from 'react-flexbox'

import { userUid ,storage} from '../../../../../firebase';



export default class Comentarios extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isUploading: false,
            progress: 0,
            file: null
        }
        // this.addComentario = this.addComentario.bind(this)
    }
    handleUploadStart = (file) => {
        this.setState({ isUploading: true, progress: 0, file: file })
    };
    handleProgress = progress => this.setState({ progress });
    handleUploadError = error => {
        this.setState({ isUploading: false });
        console.error(error);
    };
    handleUploadSuccess = filename => {
        const { file } = this.state
        this.setState({ isUploading: false, progress: 0, })
        storage
            .ref("AnexosGeral")
            .child(filename)
            .getDownloadURL()
            .then(url => this.addAnexo({
                name: file.name,
                type: file.type,
                size: file.size,
                filename: filename,
                downloadURL: url,

            }));
    };


    addAnexo(anexo) {

        let userUid1 = userUid();
        let anexoAdd = {
            data: new Date(), userUid: userUid1,
            ...anexo
        }

        const { input: { value, onChange }, label } = this.props
        let newArr = [];
        if (value)
            newArr = value.slice();

        newArr.push(anexoAdd)

        onChange(newArr)

    }
    render() {
        const { input: { value, onChange }, label } = this.props
        let listaAnexos = []
        if (value) {
            listaAnexos = value.slice();
        }
        return (
            <View column>
                <Typography>{label}</Typography>
                {this.state.isUploading ? <p>Enviando {this.state.file.name}: {this.state.progress} %</p> :

                    <FileUploader
                       
                        name="filename"
                        randomizeFilename
                        storageRef={storage.ref("AnexosGeral")}
                        onUploadStart={this.handleUploadStart}
                        onUploadError={this.handleUploadError}
                        onUploadSuccess={this.handleUploadSuccess}
                        onProgress={this.handleProgress}
                    />
                }

                {listaAnexos.map((anexo, index) => <ItemAnexo key={index} anexo={anexo} />)}

            </View>
        )
    }
}



// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/Anexos/Anexos.js